"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.invoke = exports.sleep = void 0;
var tslib_1 = require("tslib");
var errors_1 = require("./errors");
var sleep = function (ms) { return tslib_1.__awaiter(void 0, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
    return [2, new Promise(function (resolve) { return setTimeout(resolve, ms); })];
}); }); };
exports.sleep = sleep;
function runMethod(obj, method, args) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var data, error_1, axiosError, payload, _a, url, method_1, _b, status_1, statusText, data, errors;
        return tslib_1.__generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4, obj[method].apply(obj, args)];
                case 1:
                    data = (_c.sent()).data;
                    return [2, { data: data, errors: null }];
                case 2:
                    error_1 = _c.sent();
                    axiosError = error_1;
                    payload = {};
                    if (axiosError.isAxiosError && axiosError.response) {
                        _a = axiosError.config, url = _a.url, method_1 = _a.method;
                        _b = axiosError.response, status_1 = _b.status, statusText = _b.statusText, data = _b.data;
                        payload = {
                            config: { url: url, method: method_1 },
                            response: {
                                status: status_1,
                                statusText: statusText,
                                data: data,
                            },
                        };
                        errors = axiosError.response.data.errors;
                        if (errors) {
                            return [2, { data: null, errors: errors }];
                        }
                    }
                    throw new errors_1.ClientError("".concat(axiosError.message, " -> \n ").concat(axiosError.stack), payload);
                case 3: return [2];
            }
        });
    });
}
var invoke = function (obj, method) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return tslib_1.__awaiter(void 0, void 0, void 0, function () {
            var response, requestOptions, _a, delay, exponential, maxAttempts, currentAttempt, initialDelayApplied, currentDelay, error_2;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        requestOptions = args.length > 0 && args.slice(-1)[0];
                        if (!(requestOptions && requestOptions.retryPolicy)) return [3, 8];
                        _a = requestOptions.retryPolicy, delay = _a.delay, exponential = _a.exponential, maxAttempts = _a.maxAttempts;
                        currentAttempt = 1;
                        initialDelayApplied = false;
                        currentDelay = delay;
                        _b.label = 1;
                    case 1:
                        if (!(currentAttempt <= maxAttempts)) return [3, 7];
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 4, , 5]);
                        return [4, runMethod(obj, method, args)];
                    case 3:
                        response = _b.sent();
                        return [3, 7];
                    case 4:
                        error_2 = _b.sent();
                        if (currentAttempt === maxAttempts) {
                            throw error_2;
                        }
                        return [3, 5];
                    case 5:
                        if (!initialDelayApplied) {
                            initialDelayApplied = true;
                        }
                        else {
                            currentDelay = exponential
                                ? Math.pow(2, currentAttempt - 2) * 1000
                                : delay;
                        }
                        return [4, (0, exports.sleep)(currentDelay)];
                    case 6:
                        _b.sent();
                        currentAttempt++;
                        return [3, 1];
                    case 7: return [3, 10];
                    case 8: return [4, runMethod(obj, method, args)];
                    case 9:
                        response = _b.sent();
                        _b.label = 10;
                    case 10: return [2, response];
                }
            });
        });
    };
};
exports.invoke = invoke;
//# sourceMappingURL=utils.js.map